import {
    CSRF,
    formatCurrency,
    formDataToObject,
    getData,
    getDataFormToObject,
    getElement,
    resetFilter,
} from "../../../../helpers";
import { Dt } from "../../../../plugins/datatable";
import { ReceiptReturnModal } from "../receipts/modals/store";
import { PurchaseReturnsModal } from "./modals/purchasereturns";

class PurchaseReturnModule extends HTMLElement {
    async connectedCallback() {
        // console.log(this);
        const DtElement = getElement("[data-table=dt]", this);
        const BtnSearch = getElement("[name=search]", this);
        const BtnReset = getElement("[name=reset]", this);
        const BtnReceipt = getElement("#btnReceipt", this);
        const Form = getElement("[name=filter]");

        let filter = formDataToObject(Form);
        filter.type = "=";

        // Start DataTable
        let configDt = {
            processing: true, // Procesar ajax
            serverSide: true, // Mejorar velocidad ajax registros por página
            scrollY: "370px", // Define la altura de desplazamiento para el cuerpo de la tabla
            scrollCollapse: true, // Permite que el contenido colapse dentro del área definida
            fixedHeader: true, // Mantiene el encabezado visible al hacer scroll
        };

        configDt.ajax = {
            url: getData("purchaseReturnsUrlDt"),
            type: "POST",
            data: function (data) {
                data.filter = filter;
            },
            beforeSend: function (request) {
                request.setRequestHeader("X-CSRF-TOKEN", CSRF);
            },
        };
        // Columnas del AJAX
        configDt.columns = [
            {
                data: "check",
                width: "2%",
                className: "text-center",
                orderable: false,
            },
            { data: "ref", width: "5%", className: "text-center" },
            {
                data: "date_register",
                width: "6%",
            },
            {
                data: "date_invoice",
                width: "6%",
            },
            { data: "supplier_invoice" },
            { data: "supplier" },
            { data: "payment_method" },
            {
                data: "amount",
                className: "text-end",
                render: (data, type, row) => {
                    return formatCurrency(data, "decimal");
                },
            },
            {
                data: "balance",
                className: "text-end",
                render: (data, type, row) => {
                    return formatCurrency(data, "decimal");
                },
            },
            { data: "received", width: "5%", className: "text-center" },
            { data: "accounted", width: "5%", className: "text-center" },
            {
                data: "buttons",
                width: "5%",
                className: "text-center",
                orderable: false,
            },
            { data: "cif", className: "d-none" },
        ];

        const DtInvoices = new Dt(configDt);
        let T = await DtInvoices.dataTable(DtElement);
        // End DataTable

        BtnSearch?.addEventListener("click", () => {
            filter = getDataFormToObject(Form, filter);

            T.ajax.reload();
        });

        BtnReset?.addEventListener("click", () => {
            filter = formDataToObject(Form);
            filter.type = "=";

            resetFilter(Form, filter);

            T.ajax.reload();
        });

        this.addEventListener("click", (e) => {
            const Target = e.target;

            if (Target.name == "check") {
                const IptsCheck = document.querySelectorAll("[name=check]");
                let companySelected = getData(Target, "data-company");

                if (Target.checked) {
                    IptsCheck.forEach((item) => {
                        if (getData(item, "data-company") != companySelected) {
                            item.checked = false;
                            item.disabled = true;
                        }
                    });

                    BtnReceipt.classList.remove("d-none");
                } else {
                    const IptsChecked = Array.from(IptsCheck).filter(
                        (item) => item.checked
                    );

                    if (IptsChecked.length < 1) {
                        IptsCheck.forEach((item) => {
                            item.checked = false;
                            item.disabled = false;
                        });

                        BtnReceipt.classList.add("d-none");
                    }
                }
            }

            if (Target.id == "btnReceipt") {
                const RM = new ReceiptReturnModal(
                    getElement("#modalReceiptReturn")
                );
                RM.create(
                    getData(Target, "data-bs-target"),
                    getData(Target, "title"),
                    getData(Target, "data-url")
                );
            }

            if (Target.name == "btnNewReturn") {
                PurchaseReturnsModal.create(
                    getData(Target, "data-bs-target"),
                    getData(Target, "data-url"),
                    getData(Target, "title"),
                    getData(Target, "data-account")
                );
            }
        });
    }
}

window.customElements.define("purchasereturns-module", PurchaseReturnModule, {
    extends: "section",
});
